module.exports = __webpack_public_path__ + "assets/img/cancel-gray.4dd8e9dd.svg";